import { BAddItemCommand, BRemoveItemCommand } from "./commands/commands";
import { B_AttrFlags } from "./model/BBase";
import BNode from "./model/BNode";
import BPolyline from "./model/BPolyline";
import { simple_line_coordinates, simple_rect_coordinates } from "./model/BProject";
import { skLoadProject, skSaveProject } from "./store";

const addToolBarHandlers = base_class => class extends base_class {
	onToolRemoveFloorClick() {
		const floor = this.state.editingFloor;
		if (!floor) { return; }

		const bldg = floor.getOwnerBuilding();
		if (bldg) {
			const n = bldg.countFloors();
			if (n < 2) { return; }

			let fToSelect = bldg.getFloorBefore(floor);
			if (!fToSelect) {
				fToSelect = bldg.getLastFloor();
			}

			const ser = floor.serialize();
			ser._afterRemove = {
				editingFloor: fToSelect
			};

			const cmd = new BRemoveItemCommand(ser);
			this.executeCommand(cmd);
		}
	}

	onFloorSelectorFloorClick(_e, floorObjId) {
		this.selectFloorById(floorObjId);
	}

	onToolAddPolygonClick() {
		const floor = this.state.editingFloor;
		if (!floor) { return; }

		const serData = BAddItemCommand.generateSerializedDataTemplate(floor, BPolyline, {
			coordinates: [simple_rect_coordinates(25)]
		});

		const cmd = new BAddItemCommand(serData);
		this.executeCommand(cmd);
	}

	onToolAddNodeClick() {
		this.addNodeWithFlags(0);
	}

	onToolAddElevatorClick() {
		this.addNodeWithFlags(B_AttrFlags.ElevatorNode);
	}

	onToolAddStairsClick() {
		const floor = this.state.editingFloor;
		if (!floor) { return; }

		const ring = [ simple_line_coordinates(20) ];
		const serData = BAddItemCommand.generateSerializedDataTemplate(floor, BPolyline, {
			coordinates: ring,
			flags: B_AttrFlags.OpenRing | B_AttrFlags.NoBend | B_AttrFlags.Stairs
		});
		
		const cmd = new BAddItemCommand(serData);
		this.executeCommand(cmd);
	}

	addNodeWithFlags(flags) {
		const floor = this.state.editingFloor;
		if (!floor) { return; }

		const serData = BAddItemCommand.generateSerializedDataTemplate(floor, BNode, {
			coordinates: [[ [0, 0] ]],
			flags: flags
		});

		const cmd = new BAddItemCommand(serData);
		this.executeCommand(cmd);
	}

	onToolUndoClick() {
		this.state.commandStack.undoLast(this);
		this.updateUndoState();
	}

	onToolRedoClick() {
		this.state.commandStack.redo(this);
		this.updateUndoState();
	}

	onToolSaveClick() {
		skSaveProject( this.getCurrentProject() );
	}

	onToolLoadClick() {
		const loadedProject = skLoadProject();
		if (loadedProject) {
			this.setState({
				project: loadedProject,
				editingFloor: loadedProject.activeBuilding.getLastFloor()
			});

			loadedProject.updateBuildingNameList();
			loadedProject.addEventListener( this.onProjectEvent.bind(this) );
		}
	}
};

export default addToolBarHandlers;